<template>
  <b-container
    class="pt-3"
    fluid>
    <b-row>
      <b-col>
        <file-breadcrumb
          v-if="fileDetails"
          :file-details="fileDetails"
          :file-name="fileDetails.name" />
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col cols="6">
        <h5>Tree Editor</h5>
        <json-tree-editor
          :original-json="originalJSON"
          @json-change="setCode" />
      </b-col>
      <b-col cols="6">
        <div
          style="margin-bottom: 0.1rem;"
          class="d-flex bd-highlight">
          <div class="w-100 bd-highlight">
            <span class="h4">
              Changes
            </span>
            <b-form-checkbox
              v-model="showUnchanged"
              class="ml-4">
              <small>Show Unchanged</small>
            </b-form-checkbox>
          </div>
          <div class="flex-shrink-1 bd-highlight">
            <b-btn
              v-b-modal.submitApproval
              :disabled="!validForReview || !jsonDiffToSave"
              class="xl-wide"
              variant="primary">
              Review
            </b-btn>
          </div>
        </div>
        <json-diff-viewer
          :original-json="originalJSON"
          :show-unchanged="showUnchanged"
          :changed-json="changedJSON"
          @json-diff-change="setDiff" />
      </b-col>
    </b-row>
    <submit-approval-modal
      v-if="fileDetails"
      id="submitApproval"
      :file-id="fileDetails.id"
      :file-name="fileDetails.name"
      :file-details="fileDetails"
      :original-json="originalJSON"
      :json-diff="jsonDiffToSave" />
  </b-container>
</template>

<script>
  import { File } from '@/services/api'
  import SubmitApprovalModal from "@/components/SubmitApprovalModal"
  import FileBreadcrumb from "@/components/FileBreadcrumb"
  import JsonTreeEditor from "@/components/JsonTreeEditor"
  import JsonDiffViewer from "@/components/JsonDiffViewer"

  export default {
    name: "FileEditor",
    components: {JsonDiffViewer, JsonTreeEditor, FileBreadcrumb, SubmitApprovalModal},
    data() {
      return {
        fileDetails: null,
        validForReview: false,
        originalJSON: null,
        changedJSON: null,
        jsonDiffToSave: null,
        showUnchanged: false,
      }
    },
    async mounted() {
      this.fileDetails = await File.details(this.$route.params.id)
      this.originalJSON = await File.retrieve(this.$route.params.id)
    },
    methods: {
      setCode(newText) {
        try {
          this.changedJSON = JSON.parse(newText)
          this.validForReview = true
        } catch (err) {
          // unable to parse JSON, return
          this.validForReview = false
        }
      },
      setDiff(newVal) {
        this.jsonDiffToSave = newVal
      },
    },
  }
</script>

<style scoped>
  @import "~jsoneditor/dist/jsoneditor.min.css";
  @import "~jsondiffpatch/dist/formatters-styles/html.css";

  div >>> .json-tree-editor {
    width: auto;
    height: 600px;
  }

  div >>> .json-diff-viewer {
    width: auto;
    height: 600px;
  }
</style>
